const topbar = {
    docs: 'Документы',
    help: 'Помощь',
    subscription: 'Подписка',
};
export default Object.freeze(topbar);
